import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import FormControl from "react-bootstrap/FormControl";

import { useTitle } from "../../hooks/useTitle";
import { confirmPasswordReset } from "../../services/ledgerService";

import "./auth.css";

const MIN_PASSWORD_LENGTH = 8;

export function ResetPasswordPage() {
    useTitle("Set a new password");
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token") || "";

    const [status, setStatus] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        const form = e.target;
        const newPassword = form.elements.newPassword.value;
        const confirmPassword = form.elements.confirmPassword.value;

        if (newPassword.length < MIN_PASSWORD_LENGTH) {
            setError(`Password must be at least ${MIN_PASSWORD_LENGTH} characters.`);
            return;
        }
        if (newPassword !== confirmPassword) {
            setError("Passwords don't match.");
            return;
        }

        setStatus("loading");
        try {
            await confirmPasswordReset({ token, newPassword });
            navigate("/login?reset=success");
        } catch (err) {
            setStatus("error");
            setError(err.message);
        }
    };

    return (
        <section className="mkt-auth">
            <div className="mkt-auth-mast">
                <div className="mkt-auth-mast-kicker">Reset password</div>
                <h1>
                    Set a <em>new password.</em>
                </h1>
                <p>Choose a new password for your Poker Ledger account.</p>
            </div>

            <div className="mkt-auth-card">
                {!token ? (
                    <div className="mkt-auth-form">
                        <div className="mkt-auth-error">
                            This reset link is invalid or has expired.
                        </div>
                        <div className="mkt-auth-foot">
                            <a href="/forgot-password">Request a new link</a>
                        </div>
                    </div>
                ) : (
                    <>
                        <form onSubmit={handleSubmit} className="mkt-auth-form">
                            <div>
                                <label className="mkt-auth-label" htmlFor="reset-new-password">
                                    New password
                                </label>
                                <FormControl
                                    id="reset-new-password"
                                    required
                                    name="newPassword"
                                    type="password"
                                    placeholder="at least 8 characters"
                                />
                            </div>
                            <div>
                                <label className="mkt-auth-label" htmlFor="reset-confirm-password">
                                    Confirm new password
                                </label>
                                <FormControl
                                    id="reset-confirm-password"
                                    required
                                    name="confirmPassword"
                                    type="password"
                                    placeholder="re-enter your password"
                                />
                            </div>
                            <button type="submit" disabled={status === "loading"}>
                                {status === "loading" ? "Saving…" : "Reset password"}
                            </button>
                            {error && <div className="mkt-auth-error">{error}</div>}
                        </form>
                        <div className="mkt-auth-foot">
                            <a href="/login">Back to sign in</a>
                        </div>
                    </>
                )}
            </div>
        </section>
    );
}
